import { AxiosError } from 'axios';
import { clearUserCrmLogged } from '../../../utils/authenticated-user';
import { CustomError } from '../../reducers/api';

interface DataError {
  errors: string[];
  message: string;
}

export const customHttpStatusMessageTransformer = (
  responseError: AxiosError<DataError>,
  customErrors: Array<CustomError>,
) => {
  if (responseError.response?.status === 403) {
    // If using react-router-dom, you can use the navigate function
    // const navigate = useNavigate();
    // navigate('/login');

    // Or use window.location to redirect
    //window.location.href = '/admin';
    clearUserCrmLogged();
    return 'Você não tem permissão para acessar este recurso. Redirecionando para a página de login...';
  }
  if (customErrors && customErrors.length) {
    // switch (responseError.response?.status) {
    //   case 404:
    //     return customErrors.get(responseError.response?.status) as string;
    //   default:
    //     return responseError.message;
    // }
    return responseError.response?.status && customErrors.length
      ? customErrors.find((it) => it.code === responseError.response?.status)?.message
      : 'Houve algum erro com o servidor, estamos trabalhando para solucionar o problema. Por favor tente novamente!!';
  }
  switch (responseError.response?.status) {
    case 400:
      return `${responseError.response.data.message}  ${responseError.response.data?.errors?.join(
        '\n',
      )}`;
    case 404:
      return 'O recurso não foi encontrado no servidor';
    case 500:
      return 'Houve um erro indefinido no servidor, favor entrar em contato com o time técnico';
    case 413:
      return 'Upload de arquivos muito grande! O limite é 10MB por requisição.';
    default:
      return responseError.message;
  }
};
